import { FiSearch, FiMessageCircle, FiCheckCircle, FiX } from "react-icons/fi";
import { useEffect, useState } from "react";
import { ToastContainer } from "react-toastify";
import { showSuccessToast, showErrorToast } from "../../utils/toastUtils";
import "react-toastify/dist/ReactToastify.css";
import { makeRequestAuth } from "../../_config/api";

function InactiveProperties() {
  const [properties, setProperties] = useState([]);
  const [pageNo, setPageNo] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [expandedRows, setExpandedRows] = useState({});

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);
  const [notification, setNotification] = useState({ title: "", body: "" });

    const [activateModal, setActivateModal] = useState({ open: false, propertyId: null });


  const pageSize = 10;
  const maxVisiblePages = 5;

  const [filters, setFilters] = useState({
    keyword: "",
  });
  const [propertiesType, setPropertiesType] = useState("All");

  const toggleRow = (id) => {
    setExpandedRows((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  const fetchData = async () => {
    try {
      const resData = {
        keyWord: filters.keyword,
        isDisable: true,
        pageNo,
        size: pageSize,
        status: 'approved',
        sortOrder: "desc",
        sortBy: "createdAt",
        propertyType: propertiesType === "All" ? "" : propertiesType.toLowerCase(),
      };

      const response = await makeRequestAuth("post", "/admin/getPropertyList", resData);

      const list = response.data.list || [];
      setProperties(list);
      setTotalCount(response.data.total || 0);
    } catch (error) {
      showErrorToast("Failed to fetch inactive properties.");
    }
  };

  useEffect(() => {
    fetchData();
  }, [pageNo, filters, propertiesType]);

   const handleActivate = (id) => {
    setActivateModal({ open: true, propertyId: id });
  };

  const confirmActivateProperty = async () => {
    try {
      await makeRequestAuth("post", "/admin/updatePropertyDisable", {
        id: activateModal.propertyId,
      });
      showSuccessToast("Property activated successfully!");
      setActivateModal({ open: false, propertyId: null });
      fetchData();
    } catch (error) {
      showErrorToast("Failed to activate property.");
    }
  };

  const handleSendFCM = async (e) => {
    e.preventDefault();
    try {
      // Replace with your actual FCM endpoint
      await makeRequestAuth("post", "/admin/sendPropertyNotification", {
        userId: selectedProperty?.uploadBy?._id,
        title: notification.title,
        message: notification.body,
        propertyId: selectedProperty?._id
      });

      showSuccessToast("Notification sent successfully!");
      setIsModalOpen(false);
      setNotification({ title: "", body: "" });
    } catch (error) {
      showErrorToast("Failed to send notification.");
    }
  };
  const getPageNumbers = () => {
    const totalPages = Math.ceil(totalCount / pageSize);
    const start = Math.max(1, pageNo - Math.floor(maxVisiblePages / 2));
    const end = Math.min(start + maxVisiblePages - 1, totalPages);
    return Array.from({ length: end - start + 1 }, (_, i) => start + i);
  };

  const totalPages = Math.ceil(totalCount / pageSize);

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <ToastContainer position="top-right" />

      <div className="max-w-7xl mx-auto bg-white shadow-sm rounded-2xl p-6 border border-gray-100">
        {/* Header Section */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8">
          <div>
            <h2 className="text-2xl font-extrabold text-gray-900">Inactive Properties</h2>
            <p className="text-gray-500 text-sm font-medium">Manage {totalCount} disabled listings</p>
          </div>

          <div className="flex flex-wrap gap-3 w-full md:w-auto">
            <div className="relative flex-grow md:flex-initial">
              <FiSearch className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" />
              <input
                type="text"
                placeholder="Search owner or title..."
                className="pl-10 pr-4 py-2 bg-gray-50 border border-gray-200 rounded-xl focus:ring-2 focus:ring-blue-500 outline-none w-full"
                onChange={(e) => { setFilters({ ...filters, keyword: e.target.value }); setPageNo(1); }}
              />
            </div>
            <select
              className="bg-gray-50 border border-gray-200 rounded-xl px-4 py-2 text-sm outline-none focus:ring-2 focus:ring-blue-500"
              value={propertiesType}
              onChange={(e) => { setPropertiesType(e.target.value); setPageNo(1); }}
            >
              <option value="All">All Types</option>
              {
                ["apartment", "townhouse", "villa-compound", "land", "building",
                  "villa", "penthouse", "hotel-apartment", "floor", "studio",].map((type) => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))
              }
            </select>
          </div>
        </div>

        {/* List Section */}
        <div className="space-y-4">
          {properties.length === 0 ? (
            <div className="text-center py-20 text-gray-400 italic">No inactive properties found.</div>
          ) : (
            properties.map((property) => (
              <div key={property._id} className="group border border-gray-100 rounded-2xl overflow-hidden hover:shadow-md transition-shadow">
                <div className="flex flex-col lg:flex-row p-4 gap-6 bg-white">
                  {/* Image */}
                  <div className="relative h-40 w-full lg:w-48 flex-shrink-0">
                    <img
                      src={property?.uploadedPhotos?.[0] || "https://via.placeholder.com/150"}
                      className="w-full h-full object-cover rounded-xl"
                      alt="property"
                    />
                    <div className="absolute top-2 left-2 bg-red-500 text-white text-[10px] px-2 py-1 rounded-full uppercase font-bold">
                      Inactive
                    </div>
                  </div>

                  {/* Content */}
                  <div className="flex-grow">
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="text-lg font-bold text-gray-800 uppercase tracking-tight">
                          {property?.uploadBy?.name || "Unknown Owner"}
                        </h3>
                        <p className="text-blue-600 font-medium text-sm">{property?.property || "Untitled Property"}</p>
                      </div>
                      <span className="text-xs font-bold text-gray-400">ID: {property?._id?.slice(-6)}</span>
                    </div>

                    <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mt-4">
                      <div>
                        <p className="text-[10px] uppercase text-gray-400 font-bold tracking-wider">Type</p>
                        <p className="text-sm font-semibold text-gray-700">{property?.propertyType || "-"}</p>
                      </div>
                      <div>
                        <p className="text-[10px] uppercase text-gray-400 font-bold tracking-wider">Price</p>
                        <p className="text-sm font-semibold text-gray-700">₹{property?.price || "N/A"}</p>
                      </div>
                      <div>
                        <p className="text-[10px] uppercase text-gray-400 font-bold tracking-wider">Location</p>
                        <p className="text-sm font-semibold text-gray-700 truncate">{property?.city || "-"}</p>
                      </div>
                      <div>
                        <p className="text-[10px] uppercase text-gray-400 font-bold tracking-wider">Posted On</p>
                        <p className="text-sm font-semibold text-gray-700">{new Date(property.createdAt).toLocaleDateString()}</p>
                      </div>
                    </div>
                  </div>

                  {/* Actions */}
                  <div className="flex flex-row lg:flex-col gap-2 justify-center border-t lg:border-t-0 lg:border-l border-gray-100 pt-4 lg:pt-0 lg:pl-6 min-w-[160px]">
                    <button
                      onClick={() => handleActivate(property._id)}
                      className="w-full flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-xl text-sm font-bold transition-all"
                    >
                      <FiCheckCircle /> Activate
                    </button>

                    <button
                      onClick={() => toggleRow(property._id)}
                      className="text-xs text-gray-400 font-bold hover:text-blue-500 uppercase mt-1 tracking-widest"
                    >
                      {expandedRows[property._id] ? "Close Details ▲" : "View Details ▼"}
                    </button>
                  </div>
                </div>

                {/* Expanded Details */}
                {expandedRows[property._id] && (
                  <div className="bg-gray-50 p-6 border-t border-gray-100 animate-in fade-in duration-300">
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                      <div className="space-y-2">
                        <p className="text-sm"><strong>Email:</strong> {property.uploadBy?.email}</p>
                        <p className="text-sm"><strong>Phone:</strong> {property.uploadBy?.phone}</p>
                        <p className="text-sm"><strong>Address:</strong> {property.propertyAddress}</p>
                      </div>
                      <div className="md:col-span-2">
                        <p className="text-xs font-bold text-gray-400 uppercase mb-1">Full Description</p>
                        <div className="text-sm text-gray-600 bg-white p-3 rounded-lg border border-gray-200"
                          dangerouslySetInnerHTML={{ __html: property?.description }}></div>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            ))
          )}
        </div>

        {/* --- FCM MODAL --- */}
        {isModalOpen && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 backdrop-blur-sm p-4">
            <div className="bg-white rounded-3xl w-full max-w-md shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-200">
              <div className="flex justify-between items-center p-6 border-b border-gray-100">
                <h3 className="text-xl font-bold text-gray-800">Send FCM Notification</h3>
                <button onClick={() => setIsModalOpen(false)} className="text-gray-400 hover:text-gray-600"><FiX size={24} /></button>
              </div>
              <form onSubmit={handleSendFCM} className="p-6 space-y-4">
                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-1">Notification Title</label>
                  <input
                    required
                    type="text"
                    className="w-full px-4 py-2 border border-gray-200 rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none"
                    placeholder="e.g. Property Listing Update"
                    value={notification.title}
                    onChange={(e) => setNotification({ ...notification, title: e.target.value })}
                  />
                </div>
                <div>
                  <label className="block text-sm font-bold text-gray-700 mb-1">Message Description</label>
                  <textarea
                    required
                    rows="4"
                    className="w-full px-4 py-2 border border-gray-200 rounded-xl focus:ring-2 focus:ring-indigo-500 outline-none"
                    placeholder="Describe why the property is disabled or what action is needed..."
                    value={notification.body}
                    onChange={(e) => setNotification({ ...notification, body: e.target.value })}
                  ></textarea>
                </div>
                <div className="flex gap-3 pt-2">
                  <button
                    type="button"
                    onClick={() => setIsModalOpen(false)}
                    className="flex-1 px-4 py-2 bg-gray-100 text-gray-600 rounded-xl font-bold hover:bg-gray-200"
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="flex-1 px-4 py-2 bg-indigo-600 text-white rounded-xl font-bold hover:bg-indigo-700 shadow-lg shadow-indigo-200"
                  >
                    Send FCM
                  </button>
                </div>
              </form>
            </div>
          </div>
        )}

        {/* Improved Pagination */}
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-between gap-4 border-t border-gray-100 pt-6">
          <p className="text-sm text-gray-500 font-medium">
            Showing <span className="text-gray-900">{(pageNo - 1) * pageSize + 1}</span> - <span className="text-gray-900">{Math.min(pageNo * pageSize, totalCount)}</span> of {totalCount}
          </p>
          <div className="flex gap-2">
            <button
              disabled={pageNo === 1}
              onClick={() => setPageNo(p => p - 1)}
              className="px-4 py-2 rounded-xl border border-gray-200 bg-white disabled:opacity-30 hover:bg-gray-50 text-sm font-bold"
            >
              Previous
            </button>
            {getPageNumbers().map(num => (
              <button
                key={num}
                onClick={() => setPageNo(num)}
                className={`w-10 h-10 rounded-xl text-sm font-bold transition-colors ${pageNo === num ? "bg-blue-600 text-white" : "bg-white border border-gray-200 text-gray-600 hover:bg-gray-50"}`}
              >
                {num}
              </button>
            ))}
            <button
              disabled={pageNo === totalPages}
              onClick={() => setPageNo(p => p + 1)}
              className="px-4 py-2 rounded-xl border border-gray-200 bg-white disabled:opacity-30 hover:bg-gray-50 text-sm font-bold"
            >
              Next
            </button>
          </div>
        </div>
      </div>
            {/* Activate Property Confirmation Modal */}
      {activateModal.open && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl p-6 w-[90%] max-w-md shadow-2xl space-y-4 animate-in fade-in zoom-in duration-200">
            <h3 className="text-lg font-bold text-gray-800">
              Confirm Activate Property
            </h3>

            <p className="text-sm text-gray-600 leading-relaxed">
              Are you sure you want to activate this property?
            </p>

            <div className="flex justify-end gap-3 pt-2">
              <button
                onClick={() => setActivateModal({ open: false, propertyId: null })}
                className="px-4 py-2 border border-gray-200 rounded-xl text-sm font-semibold text-gray-600 hover:bg-gray-50 transition-all"
              >
                Cancel
              </button>

              <button
                onClick={confirmActivateProperty}
                className="px-5 py-2 bg-green-600 hover:bg-green-700 text-white rounded-xl text-sm font-bold transition-all shadow-md shadow-green-100"
              >
                Confirm Activate
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
}

export default InactiveProperties;